import request from '@/utils/request'

export function addFile (data) {
  return request({
    url: 'file/notcheck',
    method: 'post',
    data
  })
}
